export default __webpack_public_path__ + "static/media/dollar_white.612eb0ce.svg";